module.exports = __webpack_public_path__ + "static/img/1.2fe13dd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/1/zh/1.png
// module id = 0M8K
// module chunks = 0